import {DELETE_VERIFIED_BILL_FAILURE_DATA, DELETE_VERIFIED_BILL_REQUEST_DATA, FETCH_VERIFIED_BILL_FAILURE_DATA, FETCH_VERIFIED_BILL_REQUEST_DATA, FETCH_VERIFIED_BILL_SUCCESS_DATA } from "./verifiedBills.actionType";
export const VERIFIED_BILLS = 'VerifiedBills';

let initialState = {
    loading: false,
    verifiedBillData: []
};

export let verifiedBillsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_VERIFIED_BILL_REQUEST_DATA:
        case DELETE_VERIFIED_BILL_REQUEST_DATA:
            return {
                ...state,
                loading: true
            };

        case FETCH_VERIFIED_BILL_SUCCESS_DATA:
            return {
                ...state,
                loading: false,
                verifiedBillData: updatePayload?.BED
            };
        case FETCH_VERIFIED_BILL_FAILURE_DATA:
        case DELETE_VERIFIED_BILL_FAILURE_DATA:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};